import { getBundleResources, mapActorResource } from "./fhir.utils";
import { ActorModel, FhirClientPort, LocationResource } from "./fhir.types";

export class LocationService {
  constructor(private readonly client: FhirClientPort) {}

  async searchByName(query: string): Promise<ActorModel[]> {
    const normalized = query.trim();
    const bundle = await this.client.search("Location", {
      ...(normalized ? { name: normalized } : {}),
      status: "active",
      _count: 100,
    });

    return getBundleResources<LocationResource>(bundle, "Location").map(
      mapActorResource,
    );
  }
}
